// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"382b0bcd","453":"1bc4f8fd","455":"a58a0556","977":"4ca11c06"}[chunkId] + ".chunk.js";
};